module.exports = __webpack_public_path__ + "img/meus-dados.2f2a2f50.svg";